$(function () {
  $('.navbar-nav li.mega-dropdown').on('click', function (event) {
    $('.mega-dropdown').removeClass('active');
    $('.mega-dropdown').removeClass('present');
    
    var $this = $(this);
    if ($this.hasClass('active')) {
      $this.removeClass('active');
      setTimeout(function () {
        $this.removeClass('present');
      }, 20);
    } else {
      $this.addClass('active');
      setTimeout(function () {
        $this.addClass('present');

      }, 20);
    }
    var initState = $(event.target);
    initState.next('.mega-menu').find('.level-one').css('left', '0');
    initState.next('.mega-menu').find('.level-one').css('opacity', '1');
    initState.next('.mega-menu').find('.level-one').css('margin-left', '0%');
    initState.next('.mega-menu').find('.level-child').css('right', '-100%');
    initState.next('.mega-menu').find('.level-child').css('opacity', '0');
    initState.next('.mega-menu').find('.level-child').css('left', '100%');
    initState.next('.mega-menu').find('.level-child').css('margin-left', '0%');
    initState.next('.mega-menu').find('.level-child').children('.mega-menu-links').find('.level-child').css('right', '-100%');
    initState.next('.mega-menu').find('.level-child').children('.mega-menu-links').find('.level-child').css('opacity', '0');
    initState.next('.mega-menu').find('.level-child').children('.mega-menu-links').find('.level-child').css('left', '100%');
    event.stopImmediatePropagation()
  });

  $('.close-icon').on('click', function (event) {
    var close = $(event.target);
    close.closest('.mega-menu').parent(".mega-dropdown").removeClass('active');
    close.closest('.mega-menu').parent(".mega-dropdown").removeClass('present');
    close.closest('.level-child').prevAll('.level-one').css('left', '0');
    close.closest('.level-child').prevAll('.level-one').css('opacity', '1');
    close.closest('.level-child').css('right', '-100%');
    close.closest('.level-child').css('opacity', '0');
    event.stopImmediatePropagation();
  });

  $('.js-menu-level-down').on('click', function (event) {
    var dropdown = $(event.target);
    var rel = $(this).attr('rel');
    dropdown.closest('.level').animate({
      marginLeft: '-100%',
      opacity: 0
    }, 400);
    dropdown.closest('.level').find('div.level-child[rel="' + rel + '"]').animate({
      right: '0',
      left: '0',
      opacity: 1
    }, 400);
    dropdown.closest('.level').animate({
      opacity: 1
    }, 400);
  });

  $('.js-menu-level-up').on('click', function (event) {
    var dropdown = $(event.target);
    dropdown.closest('.level-child').parents('.level').animate({
      marginLeft: '0%',
      opacity: 0,
      left: 0
    }, 400);
    dropdown.closest('.level').animate({
      right: '-100%',
      left: '100%',
      opacity: 0
    }, 400);
    dropdown.closest('.level-child').parents('.level').animate({
      opacity: 1
    }, 400);
  });

  var mql = window.matchMedia("(max-width: 1023px)")

  mediaqueryresponse(mql)

  mql.addListener(mediaqueryresponse)

  function mediaqueryresponse(mql) {
    if (mql.matches) {
      $('.navbar-nav.push-right').detach().insertBefore('.navbar-toggle');

      $('.js-menu-header').on('click', function (index) {
        event.preventDefault();
        var i;
        for (i = 0; i < $('.js-menu-header').length; i++) {
          $('.js-menu-header:eq(' + i + ')').fadeOut(400);
          $('.js-menu-header:eq(' + i + ')').animate({
            marginRight: '100%'
          }, 400);
        };
        $(this).next('.mega-menu').animate({
          marginLeft: '0',
          opacity: 1
        }, 400);
        $(this).parents('.main').prev('.mobile-menu-header').fadeOut(400);
        $(this).parents('.main').next('.mobile-language').fadeOut(400);
      });

      $('.js-menu-level-one').on('click', function (event) {
        var i;
        for (i = 0; i < $(".js-menu-header").length; i++) {
          $('.js-menu-header:eq(' + i + ')').fadeIn(400);
          $('.js-menu-header:eq(' + i + ')').animate({
            marginRight: '0'
          }, 400);
        };

        $(this).parents('.mega-menu').animate({
          marginLeft: '100%',
          opacity: 0
        }, 400);

        $(this).parents('.main').prev('.mobile-menu-header').fadeIn(400);
        $(this).parents('.main').next('.mobile-language').fadeIn(400);
      });
      $('.navbar-toggle').on('click', function (event) {
        var i;
        for (i = 0; i < $(".js-menu-header").length; i++) {
          $('.js-menu-header:eq(' + i + ')').fadeIn(400);
          $('.js-menu-header:eq(' + i + ')').animate({
            marginRight: '0'
          }, 400);
        };
        $('.mobile-menu-header').fadeIn(400);
        $('.mobile-language').fadeIn(400);
        $('.mega-dropdown').removeClass('active');
      });

      $('.js-mega-dropdown-toggle').on('click', function (event) {
        event.preventDefault();
        var loginSearch = $(event.target);
        loginSearch.parents('.push-right').next('.navbar-toggle').addClass('collapsed');
        loginSearch.parents('.navbar-header').next('.navbar-collapse').removeClass('in');
      });
      $('.js-menu-level-up a').text(function () {
        $(this).hide();
      })

    } else {
      event.preventDefault();
      $('.navbar-nav.push-right').detach().insertAfter('#main');
      $('.js-menu-header').unbind('click');
      $('.mobile-menu-header').css('display', 'none');
      $('.navbar-collapse').css('height', '75px');
      $('.js-menu-level-up a').text(function () {
        $(this).show();
      })
    }
  };
  /* ================================== Search Query ====================================== */
  $.getJSON('https://api.myjson.com/bins/169o4a', function (data) {
    var search = data.map(function (val) {
      return val.term
    })
    auto(search)
  });

  function auto(search) {
    $('#search_suggestion').autocomplete({
      source: search,
      minLength: 1
    });
    $('.ui-autocomplete').detach().insertAfter('#search_suggestion').css('position', 'absolute');
  }

  $.ui.autocomplete.filter = function (array, term) {
    var matcher = new RegExp("\\b" + $.ui.autocomplete.escapeRegex(term), "i");
    return $.grep(array, function (value) {
      return matcher.test(value.label || value.value || value);
    });
  };

  function highlightAutocomplete() {
    $.ui.autocomplete.prototype._renderItem = function (ul, item) {
      var re = new RegExp("\\b" + this.term, 'gi');
      var t = item.label.replace(re, "<span style='font-weight:bold;background: rgba(255,193,7,1); text-transform: capitalize'>" +
        this.term +
        "</span>");
      return $("<li></li>")
        .data("item.menu", item)
        .append("<div>" + t + "</div>")
        .appendTo(ul);
    };
  }
  highlightAutocomplete();
});
